export default __webpack_public_path__ + "static/media/Lymphdrainage.a5c27340.jpeg";